/**
 * @generated SignedSource<<8385797584b64d89a97710a63009d73a>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type CodeScanningSecurityAlertStatus = "DISMISSED" | "FIXED" | "OPEN" | "%future added value";
export type CommentAuthorAssociation = "COLLABORATOR" | "CONTRIBUTOR" | "FIRST_TIMER" | "FIRST_TIME_CONTRIBUTOR" | "MANNEQUIN" | "MEMBER" | "NONE" | "OWNER" | "%future added value";
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type IssueStateReason = "COMPLETED" | "DUPLICATE" | "NOT_PLANNED" | "REOPENED" | "%future added value";
export type IssueTypeColor = "BLUE" | "GRAY" | "GREEN" | "ORANGE" | "PINK" | "PURPLE" | "RED" | "YELLOW" | "%future added value";
export type PullRequestState = "CLOSED" | "MERGED" | "OPEN" | "%future added value";
export type ReactionContent = "CONFUSED" | "EYES" | "HEART" | "HOORAY" | "LAUGH" | "ROCKET" | "THUMBS_DOWN" | "THUMBS_UP" | "%future added value";
export type RepositoryVisibility = "INTERNAL" | "PRIVATE" | "PUBLIC" | "%future added value";
export type ThreadSubscriptionEvent = "CLOSED" | "REOPENED" | "%future added value";
export type ThreadSubscriptionFormAction = "NONE" | "SUBSCRIBE" | "UNSUBSCRIBE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type IssueViewerSecondaryViewQueryData$data = {
  readonly issue: {
    readonly agentAssignments: ReadonlyArray<{
      readonly __typename: "AgentAssignment";
    }>;
    readonly authorAssociation: CommentAuthorAssociation;
    readonly blockedBy: {
      readonly nodes: ReadonlyArray<{
        readonly number: number;
        readonly repository: {
          readonly name: string;
          readonly owner: {
            readonly login: string;
          };
        };
        readonly titleHTML: string;
        readonly url: string;
      } | null | undefined> | null | undefined;
    };
    readonly closedByPullRequestsReferences: {
      readonly nodes: ReadonlyArray<{
        readonly __typename: "PullRequest";
        readonly createdAt: string;
        readonly databaseId: number | null | undefined;
        readonly id: string;
        readonly isDraft: boolean;
        readonly isInMergeQueue: boolean;
        readonly number: number;
        readonly repository: {
          readonly id: string;
          readonly name: string;
          readonly nameWithOwner: string;
          readonly owner: {
            readonly __typename: string;
            readonly id: string;
            readonly login: string;
          };
        };
        readonly state: PullRequestState;
        readonly title: string;
        readonly url: string;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly databaseId: number | null | undefined;
    readonly discussion: {
      readonly url: string;
    } | null | undefined;
    readonly id: string;
    readonly isTransferInProgress: boolean;
    readonly issueDependenciesSummary: {
      readonly blockedBy: number;
      readonly blocking: number;
    };
    readonly issueType: {
      readonly color: IssueTypeColor;
      readonly name: string;
    } | null | undefined;
    readonly lastEditedAt: string | null | undefined;
    readonly lastUserContentEdit: {
      readonly editor: {
        readonly login: string;
        readonly url: string;
      } | null | undefined;
    } | null | undefined;
    readonly linkedBranches: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly ref: {
          readonly __typename: "Ref";
          readonly associatedPullRequests: {
            readonly totalCount: number;
          };
          readonly id: string;
          readonly name: string;
          readonly repository: {
            readonly defaultBranchRef: {
              readonly associatedPullRequests: {
                readonly totalCount: number;
              };
              readonly id: string;
              readonly name: string;
              readonly target: {
                readonly id: string;
                readonly oid: any;
              } | null | undefined;
            } | null | undefined;
            readonly id: string;
            readonly nameWithOwner: string;
          };
          readonly target: {
            readonly id: string;
            readonly oid: any;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly linkedPullRequestReleases: {
      readonly nodes: ReadonlyArray<{
        readonly pullRequest: {
          readonly id: string;
        } | null | undefined;
        readonly release: {
          readonly id: string;
          readonly isLatest: boolean;
          readonly isPrerelease: boolean;
          readonly name: string | null | undefined;
          readonly tagName: string;
          readonly url: string;
        };
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly milestone: {
      readonly closed: boolean;
      readonly closedAt: string | null | undefined;
      readonly dueOn: string | null | undefined;
      readonly id: string;
      readonly progressPercentage: number;
      readonly title: string;
      readonly url: string;
    } | null | undefined;
    readonly number: number;
    readonly parent: {
      readonly id: string;
      readonly number: number;
      readonly repository: {
        readonly name: string;
        readonly nameWithOwner: string;
        readonly owner: {
          readonly login: string;
        };
      };
      readonly state: IssueState;
      readonly stateReason: IssueStateReason | null | undefined;
      readonly subIssuesSummary: {
        readonly completed: number;
        readonly total: number;
      };
      readonly title: string;
      readonly titleHTML: string;
      readonly url: string;
    } | null | undefined;
    readonly participants: {
      readonly nodes: ReadonlyArray<{
        readonly avatarUrl: string;
        readonly id: string;
        readonly login: string;
      } | null | undefined> | null | undefined;
      readonly totalCount: number;
    };
    readonly pinnedIssueComment: {
      readonly id: string;
      readonly issueComment: {
        readonly id: string;
        readonly showSpammyBadge: boolean;
      };
    } | null | undefined;
    readonly projectItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly project: {
            readonly closed: boolean;
            readonly hasReachedItemsLimit: boolean;
            readonly id: string;
            readonly number: number;
            readonly title: string;
            readonly url: string;
            readonly viewerCanUpdate: boolean;
          };
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly reactionGroups: ReadonlyArray<{
      readonly content: ReactionContent;
      readonly viewerHasReacted: boolean;
    }> | null | undefined;
    readonly repository: {
      readonly codeOfConductFileUrl: string | null | undefined;
      readonly contributingFileUrl: string | null | undefined;
      readonly databaseId: number | null | undefined;
      readonly id: string;
      readonly isArchived: boolean;
      readonly isLocked: boolean;
      readonly isPrivate: boolean;
      readonly isWritable: boolean;
      readonly name: string;
      readonly nameWithOwner: string;
      readonly owner: {
        readonly login: string;
      };
      readonly securityPolicyUrl: string | null | undefined;
      readonly slashCommandsEnabled: boolean;
      readonly supportFileUrl: string | null | undefined;
      readonly viewerCanCreateIssues: boolean;
      readonly viewerCanPinIssues: boolean;
      readonly viewerCanPush: boolean;
      readonly visibility: RepositoryVisibility;
    };
    readonly securityAlerts: {
      readonly nodes: ReadonlyArray<{
        readonly number: number | null | undefined;
        readonly repository: {
          readonly name: string;
          readonly nameWithOwner: string;
          readonly owner: {
            readonly login: string;
          };
        } | null | undefined;
        readonly status: CodeScanningSecurityAlertStatus | null | undefined;
        readonly title: string | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly showSpammyBadge: boolean;
    readonly state: IssueState;
    readonly stateReason: IssueStateReason | null | undefined;
    readonly subIssues: {
      readonly nodes: ReadonlyArray<{
        readonly assignees: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly avatarUrl: string;
              readonly id: string;
              readonly login: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
          readonly totalCount: number;
        };
        readonly closed: boolean;
        readonly closedByPullRequestsReferences: {
          readonly totalCount: number;
        } | null | undefined;
        readonly databaseId: number | null | undefined;
        readonly id: string;
        readonly issueDependenciesSummary: {
          readonly blockedBy: number;
        };
        readonly issueType: {
          readonly color: IssueTypeColor;
          readonly id: string;
          readonly name: string;
        } | null | undefined;
        readonly number: number;
        readonly repository: {
          readonly name: string;
          readonly owner: {
            readonly login: string;
          };
        };
        readonly state: IssueState;
        readonly stateReason: IssueStateReason | null | undefined;
        readonly subIssuesSummary: {
          readonly completed: number;
          readonly total: number;
        };
        readonly title: string;
        readonly titleHTML: string;
        readonly url: string;
      } | null | undefined> | null | undefined;
    };
    readonly subIssuesConnection: {
      readonly totalCount: number;
    };
    readonly subIssuesSummary: {
      readonly completed: number;
      readonly total: number;
    };
    readonly suggestedActors: {
      readonly nodes: ReadonlyArray<{
        readonly __typename?: string;
        readonly avatarUrl?: string;
        readonly displayName?: string;
        readonly id?: string;
        readonly isAgent?: boolean;
        readonly isCopilot?: boolean;
        readonly login?: string;
        readonly name?: string | null | undefined;
        readonly profileResourcePath?: string | null | undefined;
      } | null | undefined> | null | undefined;
    };
    readonly threadSubscriptionChannel: string | null | undefined;
    readonly title: string;
    readonly titleHTML: string;
    readonly topBlockedBy: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly number: number;
        readonly repository: {
          readonly name: string;
          readonly nameWithOwner: string;
          readonly owner: {
            readonly login: string;
          };
        };
        readonly state: IssueState;
        readonly stateReason: IssueStateReason | null | undefined;
        readonly title: string;
        readonly titleHTML: string;
        readonly url: string;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    };
    readonly topBlocking: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly number: number;
        readonly repository: {
          readonly name: string;
          readonly nameWithOwner: string;
          readonly owner: {
            readonly login: string;
          };
        };
        readonly state: IssueState;
        readonly stateReason: IssueStateReason | null | undefined;
        readonly title: string;
        readonly titleHTML: string;
        readonly url: string;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
    };
    readonly topRelatesTo: {
      readonly nodes: ReadonlyArray<{
        readonly id: string;
        readonly number: number;
        readonly repository: {
          readonly name: string;
          readonly nameWithOwner: string;
          readonly owner: {
            readonly login: string;
          };
        };
        readonly state: IssueState;
        readonly stateReason: IssueStateReason | null | undefined;
        readonly title: string;
        readonly titleHTML: string;
        readonly url: string;
      } | null | undefined> | null | undefined;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      };
      readonly totalCount: number;
    };
    readonly trackedInIssues: {
      readonly nodes: ReadonlyArray<{
        readonly number: number;
        readonly stateReason: IssueStateReason | null | undefined;
        readonly url: string;
      } | null | undefined> | null | undefined;
      readonly totalCount: number;
    };
    readonly url: string;
    readonly viaApp: {
      readonly name: string;
      readonly slug: string;
      readonly url: string;
    } | null | undefined;
    readonly viewerCanBlockFromOrg: boolean;
    readonly viewerCanBlockPersonally: boolean;
    readonly viewerCanClose: boolean;
    readonly viewerCanConvertToDiscussion: boolean | null | undefined;
    readonly viewerCanDelete: boolean;
    readonly viewerCanLinkBranches: boolean;
    readonly viewerCanLock: boolean | null | undefined;
    readonly viewerCanReadUserContentEdits: boolean;
    readonly viewerCanReopen: boolean;
    readonly viewerCanReport: boolean;
    readonly viewerCanReportToMaintainer: boolean;
    readonly viewerCanTransfer: boolean;
    readonly viewerCanType: boolean | null | undefined;
    readonly viewerCanUnblockFromOrg: boolean;
    readonly viewerCanUnblockPersonally: boolean;
    readonly viewerCanUpdateMetadata: boolean | null | undefined;
    readonly viewerCustomSubscriptionEvents: ReadonlyArray<ThreadSubscriptionEvent> | null | undefined;
    readonly viewerThreadSubscriptionFormAction: ThreadSubscriptionFormAction | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "IssueViewerSecondaryViewQueryData";
};
export type IssueViewerSecondaryViewQueryData$key = {
  readonly " $data"?: IssueViewerSecondaryViewQueryData$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueViewerSecondaryViewQueryData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nameWithOwner",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "login",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": [
    (v4/*:: as any*/)
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stateReason",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "titleHTML",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "SubIssuesSummary",
  "kind": "LinkedField",
  "name": "subIssuesSummary",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "completed",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v13 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v14 = [
  (v13/*:: as any*/)
],
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "size",
      "value": 64
    }
  ],
  "kind": "ScalarField",
  "name": "avatarUrl",
  "storageKey": "avatarUrl(size:64)"
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "closed",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasNextPage",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": null,
  "kind": "LinkedField",
  "name": "target",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "oid",
      "storageKey": null
    },
    (v0/*:: as any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v21 = [
  (v20/*:: as any*/)
],
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "PullRequestConnection",
  "kind": "LinkedField",
  "name": "associatedPullRequests",
  "plural": false,
  "selections": (v21/*:: as any*/),
  "storageKey": null
},
v23 = {
  "kind": "Literal",
  "name": "includeClosedPrs",
  "value": true
},
v24 = {
  "kind": "Literal",
  "name": "ranked",
  "value": true
},
v25 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 3
  },
  (v24/*:: as any*/)
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v3/*:: as any*/),
    (v2/*:: as any*/),
    (v5/*:: as any*/)
  ],
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Issue",
  "kind": "LinkedField",
  "name": "nodes",
  "plural": true,
  "selections": [
    (v0/*:: as any*/),
    (v8/*:: as any*/),
    (v9/*:: as any*/),
    (v10/*:: as any*/),
    (v1/*:: as any*/),
    (v26/*:: as any*/),
    (v6/*:: as any*/),
    (v7/*:: as any*/)
  ],
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v18/*:: as any*/)
  ],
  "storageKey": null
},
v29 = [
  (v27/*:: as any*/),
  (v28/*:: as any*/)
],
v30 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "blockedBy",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showSpammyBadge",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "concreteType": "Repository",
  "kind": "LinkedField",
  "name": "repository",
  "plural": false,
  "selections": [
    (v2/*:: as any*/),
    (v5/*:: as any*/)
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": true,
      "kind": "LocalArgument",
      "name": "markAsRead"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "number"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": null,
        "cursor": null,
        "direction": "forward",
        "path": [
          "issue",
          "projectItems"
        ]
      }
    ]
  },
  "name": "IssueViewerSecondaryViewQueryData",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "markAsRead",
          "variableName": "markAsRead"
        },
        {
          "kind": "Variable",
          "name": "number",
          "variableName": "number"
        }
      ],
      "concreteType": "Issue",
      "kind": "LinkedField",
      "name": "issue",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isTransferInProgress",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Issue",
          "kind": "LinkedField",
          "name": "parent",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            (v1/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Repository",
              "kind": "LinkedField",
              "name": "repository",
              "plural": false,
              "selections": [
                (v2/*:: as any*/),
                (v3/*:: as any*/),
                (v5/*:: as any*/)
              ],
              "storageKey": null
            },
            (v6/*:: as any*/),
            (v7/*:: as any*/),
            (v8/*:: as any*/),
            (v9/*:: as any*/),
            (v10/*:: as any*/),
            (v11/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanReopen",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanClose",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "authorAssociation",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerThreadSubscriptionFormAction",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ReactionGroup",
          "kind": "LinkedField",
          "name": "reactionGroups",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "content",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerHasReacted",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Repository",
          "kind": "LinkedField",
          "name": "repository",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            (v12/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLocked",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isWritable",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanPush",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slashCommandsEnabled",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "codeOfConductFileUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "securityPolicyUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "contributingFileUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "supportFileUrl",
              "storageKey": null
            },
            (v2/*:: as any*/),
            (v3/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isArchived",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanPinIssues",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "viewerCanCreateIssues",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isPrivate",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "visibility",
              "storageKey": null
            },
            (v5/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v14/*:: as any*/),
          "concreteType": "AssigneeConnection",
          "kind": "LinkedField",
          "name": "suggestedActors",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    (v15/*:: as any*/),
                    (v0/*:: as any*/),
                    (v4/*:: as any*/),
                    (v2/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "profileResourcePath",
                      "storageKey": null
                    },
                    (v16/*:: as any*/),
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isCopilot",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isAgent",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "displayName",
                          "storageKey": null
                        }
                      ],
                      "type": "Bot",
                      "abstractKey": null
                    }
                  ],
                  "type": "Actor",
                  "abstractKey": "__isActor"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "suggestedActors(first:10)"
        },
        {
          "alias": "projectItems",
          "args": null,
          "concreteType": "ProjectV2ItemConnection",
          "kind": "LinkedField",
          "name": "__ProjectSection_projectItems_connection",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ProjectV2ItemEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ProjectV2Item",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ProjectV2",
                      "kind": "LinkedField",
                      "name": "project",
                      "plural": false,
                      "selections": [
                        (v0/*:: as any*/),
                        (v8/*:: as any*/),
                        (v17/*:: as any*/),
                        (v1/*:: as any*/),
                        (v10/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "viewerCanUpdate",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "hasReachedItemsLimit",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    (v15/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                (v18/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Milestone",
          "kind": "LinkedField",
          "name": "milestone",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            (v8/*:: as any*/),
            (v17/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dueOn",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "progressPercentage",
              "storageKey": null
            },
            (v10/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "closedAt",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v8/*:: as any*/),
        (v9/*:: as any*/),
        (v1/*:: as any*/),
        (v12/*:: as any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 25
            }
          ],
          "concreteType": "LinkedBranchConnection",
          "kind": "LinkedField",
          "name": "linkedBranches",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkedBranch",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v0/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Ref",
                  "kind": "LinkedField",
                  "name": "ref",
                  "plural": false,
                  "selections": [
                    (v2/*:: as any*/),
                    (v0/*:: as any*/),
                    (v15/*:: as any*/),
                    (v19/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Repository",
                      "kind": "LinkedField",
                      "name": "repository",
                      "plural": false,
                      "selections": [
                        (v0/*:: as any*/),
                        (v3/*:: as any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Ref",
                          "kind": "LinkedField",
                          "name": "defaultBranchRef",
                          "plural": false,
                          "selections": [
                            (v2/*:: as any*/),
                            (v0/*:: as any*/),
                            (v19/*:: as any*/),
                            (v22/*:: as any*/)
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    (v22/*:: as any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "linkedBranches(first:25)"
        },
        {
          "alias": null,
          "args": [
            (v13/*:: as any*/),
            (v23/*:: as any*/)
          ],
          "concreteType": "PullRequestConnection",
          "kind": "LinkedField",
          "name": "closedByPullRequestsReferences",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PullRequest",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v0/*:: as any*/),
                (v10/*:: as any*/),
                (v1/*:: as any*/),
                (v8/*:: as any*/),
                (v6/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isDraft",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isInMergeQueue",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "createdAt",
                  "storageKey": null
                },
                (v12/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Repository",
                  "kind": "LinkedField",
                  "name": "repository",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    (v2/*:: as any*/),
                    (v3/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "owner",
                      "plural": false,
                      "selections": [
                        (v0/*:: as any*/),
                        (v4/*:: as any*/),
                        (v15/*:: as any*/)
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                (v15/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "closedByPullRequestsReferences(first:10,includeClosedPrs:true)"
        },
        {
          "alias": null,
          "args": (v14/*:: as any*/),
          "concreteType": "LinkedPullRequestReleaseConnection",
          "kind": "LinkedField",
          "name": "linkedPullRequestReleases",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "LinkedPullRequestRelease",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PullRequest",
                  "kind": "LinkedField",
                  "name": "pullRequest",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Release",
                  "kind": "LinkedField",
                  "name": "release",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "tagName",
                      "storageKey": null
                    },
                    (v2/*:: as any*/),
                    (v10/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isPrerelease",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "isLatest",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "linkedPullRequestReleases(first:10)"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanLinkBranches",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanUpdateMetadata",
          "storageKey": null
        },
        {
          "alias": "topBlockedBy",
          "args": (v25/*:: as any*/),
          "concreteType": "IssueConnection",
          "kind": "LinkedField",
          "name": "blockedBy",
          "plural": false,
          "selections": (v29/*:: as any*/),
          "storageKey": "blockedBy(first:3,ranked:true)"
        },
        {
          "alias": "topBlocking",
          "args": (v25/*:: as any*/),
          "concreteType": "IssueConnection",
          "kind": "LinkedField",
          "name": "blocking",
          "plural": false,
          "selections": (v29/*:: as any*/),
          "storageKey": "blocking(first:3,ranked:true)"
        },
        {
          "alias": "topRelatesTo",
          "args": (v25/*:: as any*/),
          "concreteType": "IssueConnection",
          "kind": "LinkedField",
          "name": "relatesTo",
          "plural": false,
          "selections": [
            (v20/*:: as any*/),
            (v27/*:: as any*/),
            (v28/*:: as any*/)
          ],
          "storageKey": "relatesTo(first:3,ranked:true)"
        },
        {
          "alias": null,
          "args": (v30/*:: as any*/),
          "concreteType": "CodeScanningSecurityAlertConnection",
          "kind": "LinkedField",
          "name": "securityAlerts",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "CodeScanningSecurityAlert",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v1/*:: as any*/),
                (v26/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                (v8/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "securityAlerts(first:100)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "IssueDependenciesSummary",
          "kind": "LinkedField",
          "name": "issueDependenciesSummary",
          "plural": false,
          "selections": [
            (v31/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "blocking",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "threadSubscriptionChannel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCustomSubscriptionEvents",
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v14/*:: as any*/),
          "concreteType": "UserConnection",
          "kind": "LinkedField",
          "name": "participants",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v4/*:: as any*/),
                (v16/*:: as any*/),
                (v0/*:: as any*/)
              ],
              "storageKey": null
            },
            (v20/*:: as any*/)
          ],
          "storageKey": "participants(first:10)"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanConvertToDiscussion",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanDelete",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanTransfer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanLock",
          "storageKey": null
        },
        (v7/*:: as any*/),
        (v10/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "IssueType",
          "kind": "LinkedField",
          "name": "issueType",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            (v32/*:: as any*/)
          ],
          "storageKey": null
        },
        (v11/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "AgentAssignment",
          "kind": "LinkedField",
          "name": "agentAssignments",
          "plural": true,
          "selections": [
            (v15/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v14/*:: as any*/),
          "concreteType": "IssueConnection",
          "kind": "LinkedField",
          "name": "trackedInIssues",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Issue",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v1/*:: as any*/),
                (v10/*:: as any*/),
                (v7/*:: as any*/)
              ],
              "storageKey": null
            },
            (v20/*:: as any*/)
          ],
          "storageKey": "trackedInIssues(first:10)"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanReadUserContentEdits",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastEditedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "UserContentEdit",
          "kind": "LinkedField",
          "name": "lastUserContentEdit",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "editor",
              "plural": false,
              "selections": [
                (v10/*:: as any*/),
                (v4/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        (v33/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "App",
          "kind": "LinkedField",
          "name": "viaApp",
          "plural": false,
          "selections": [
            (v2/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            },
            (v10/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanReport",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanReportToMaintainer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanBlockFromOrg",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanUnblockFromOrg",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanBlockPersonally",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "viewerCanUnblockPersonally",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PinnedIssueComment",
          "kind": "LinkedField",
          "name": "pinnedIssueComment",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "IssueComment",
              "kind": "LinkedField",
              "name": "issueComment",
              "plural": false,
              "selections": [
                (v0/*:: as any*/),
                (v33/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": "subIssuesConnection",
          "args": null,
          "concreteType": "IssueConnection",
          "kind": "LinkedField",
          "name": "subIssues",
          "plural": false,
          "selections": (v21/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": (v30/*:: as any*/),
          "concreteType": "IssueConnection",
          "kind": "LinkedField",
          "name": "subIssues",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Issue",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v0/*:: as any*/),
                (v17/*:: as any*/),
                (v6/*:: as any*/),
                (v7/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IssueDependenciesSummary",
                  "kind": "LinkedField",
                  "name": "issueDependenciesSummary",
                  "plural": false,
                  "selections": [
                    (v31/*:: as any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": (v14/*:: as any*/),
                  "concreteType": "UserConnection",
                  "kind": "LinkedField",
                  "name": "assignees",
                  "plural": false,
                  "selections": [
                    (v20/*:: as any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "UserEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "User",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*:: as any*/),
                            (v4/*:: as any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "avatarUrl",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "assignees(first:10)"
                },
                (v10/*:: as any*/),
                (v34/*:: as any*/),
                (v12/*:: as any*/),
                (v1/*:: as any*/),
                (v8/*:: as any*/),
                (v9/*:: as any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "IssueType",
                  "kind": "LinkedField",
                  "name": "issueType",
                  "plural": false,
                  "selections": [
                    (v0/*:: as any*/),
                    (v2/*:: as any*/),
                    (v32/*:: as any*/)
                  ],
                  "storageKey": null
                },
                (v11/*:: as any*/),
                {
                  "alias": null,
                  "args": [
                    {
                      "kind": "Literal",
                      "name": "first",
                      "value": 0
                    },
                    (v23/*:: as any*/)
                  ],
                  "concreteType": "PullRequestConnection",
                  "kind": "LinkedField",
                  "name": "closedByPullRequestsReferences",
                  "plural": false,
                  "selections": (v21/*:: as any*/),
                  "storageKey": "closedByPullRequestsReferences(first:0,includeClosedPrs:true)"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": "subIssues(first:100)"
        },
        (v6/*:: as any*/),
        {
          "alias": null,
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 1
            },
            (v24/*:: as any*/)
          ],
          "concreteType": "IssueConnection",
          "kind": "LinkedField",
          "name": "blockedBy",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Issue",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v9/*:: as any*/),
                (v1/*:: as any*/),
                (v10/*:: as any*/),
                (v34/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": "blockedBy(first:1,ranked:true)"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Discussion",
          "kind": "LinkedField",
          "name": "discussion",
          "plural": false,
          "selections": [
            (v10/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Repository",
  "abstractKey": null
};
})();

(node as any).hash = "11627c0b4b12e26843baae630d876d56";

export default node;
